module.exports = __webpack_public_path__ + "img/2.d9a95954.png";